module.exports = __webpack_public_path__ + "img/przedruk_loader2.10bdaf82.gif";